import {get as _get, isEmpty as _isEmpty, findIndex as _findIndex} from 'lodash';
import {withRouter} from 'react-router-dom';

import {
    getDeviceNameById, setCountryRestrictionsForDevices, setSubdivisionsRestrictionsForDevices,
} from '@modules/events/utils/eventsBookingGeoRestriction';
import {
    DEVICE_CATEGORY_DESKTOP, DEVICE_CATEGORY_DESKTOP_LABEL,
    DEVICE_CATEGORY_MOBILE, DEVICE_CATEGORY_MOBILE_LABEL,
    DEVICE_CATEGORY_SMART_TV, DEVICE_CATEGORY_SMART_TV_LABEL,
} from '@constants/variables';
import {GetEventEventBookingForGeoRestrictionsForm} from '@graphql/eventEventBooking/query';
import {convertToInt} from '@utils/helpers';
import {
    getEventBookingDataFromAllSteps,
    showDefaultDeleteModal,
} from '@modules/events/utils/EventEventBooking/eventBookingDataFromAllSteps';
import {EventEventBookingGeoRestrictionsForm} from '@modules/eventBooking/forms/EventEventBookingGeoRestrictionsForm';
import {editValidation, onCloseModal, setMutationSuccess} from '@modules/eventBooking/forms/helpers/helpers';

export class EventEventBookingGeoRestrictionsEditForm extends EventEventBookingGeoRestrictionsForm {
    countryTreeOptions = null;
    subdivisionTreeOptions = null;
    DEVICE_CATEGORIES = [DEVICE_CATEGORY_DESKTOP, DEVICE_CATEGORY_MOBILE, DEVICE_CATEGORY_SMART_TV];

    prepareDataForSubmit = () => {
        return getEventBookingDataFromAllSteps(this.props.stepsMethods, convertToInt(this.props.formParams.optionsVariables.id));
    };

    onFormSubmit = (data) => {
        if (editValidation(this.props.stepsMethods)) {
            this.setState(() => ({
                defaultForm_loading: true,
            }));
            super.onFormSubmit(data);
        }
    };

    componentDidMount() {
        this.setUpdateSuccessCallback(() => {
            if (this.props.formParams.optionsVariables.event) {
                setMutationSuccess(this.props);
            }

            onCloseModal(
                this.props.formParams.optionsVariables.event,
                this.props.formParams.optionsVariables.client,
                this.props.Modal.setModal,
                this.props
            );
        });
        this.setDeleteSuccessCallback(() => {
            if (this.props.formParams.optionsVariables.event) {
                setMutationSuccess(this.props);
            }

            onCloseModal(
                this.props.formParams.optionsVariables.event,
                this.props.formParams.optionsVariables.client,
                this.props.Modal.setModal,
                this.props
            );
        });

        this.queryGetSelectedGeoRestrictions();
        this.setField('desktop_switch', {
            hidden: true,
        });
        this.setField('mobile_switch', {
            hidden: true,
        });
        this.setField('smart_tv_switch', {
            hidden: true,
        });
    }

    queryGetSelectedGeoRestrictions = () => {
        this.setState(() => ({queryGetSelectedGeoRestrictionsLoading: true}));

        return this.runApolloRequest('query', {
            fetchPolicy: 'network-only',
            query: GetEventEventBookingForGeoRestrictionsForm,
            variables: {
                id: this.props.formParams.optionsVariables.id,
            },
        }).then((response) => {
            this.setState(() => ({
                selectedGeoRestrictions: response.data,
            }));

        }).catch((response) => {
            this.props.MessageBox.addMessage(
                'formInnerErrorMessage',
                'Can\'t get selected event booking geo restrictions',
                response.message,
                'error'
            );
        });
    };

    addSelectedGeoRestrictions = (selectedGeoRestrictions) => {
        const switches = {
            [DEVICE_CATEGORY_DESKTOP_LABEL]: 'desktop_switch',
            [DEVICE_CATEGORY_MOBILE_LABEL]: 'mobile_switch',
            [DEVICE_CATEGORY_SMART_TV_LABEL]: 'smart_tv_switch',
        };
        const devices = {
            [DEVICE_CATEGORY_DESKTOP_LABEL]: 'desktop_countries',
            [DEVICE_CATEGORY_MOBILE_LABEL]: 'mobile_countries',
            [DEVICE_CATEGORY_SMART_TV_LABEL]: 'smart_tv_countries',

        };
        const sub = {
            [DEVICE_CATEGORY_DESKTOP_LABEL]: 'desktop_subdivisions',
            [DEVICE_CATEGORY_MOBILE_LABEL]: 'mobile_subdivisions',
            [DEVICE_CATEGORY_SMART_TV_LABEL]: 'smart_tv_subdivisions',
        };

        selectedGeoRestrictions?.map((selectedGeoRestriction) => {
            const isCountrySelected = (country, countries) => {
                return !!countries.find(i => i === country);
            };

            const tree = this.props.GraphQLOptionsData.continents.map((item) => {
                const countries = item.children.map(i => {
                    return {
                        id: i.id,
                        value: i.value,
                        name: i.text,
                        label: i.text,
                        selected: isCountrySelected(i.value, selectedGeoRestriction.country_iso_alpha2_codes),
                    };
                });

                return {value: item.value, name: item.text, label: item.text, children: [...countries]};
            });

            this.setField(switches[selectedGeoRestriction.device_category.name], {
                hidden: false,
                checked: true,
                defaultValue: true,
            });

            this.setField(devices[selectedGeoRestriction.device_category.name], {
                hidden: false,
                options: tree,
            });

            const filteredCountries = this.props.GraphQLOptionsData.countries
                .filter(item => selectedGeoRestriction.country_iso_alpha2_codes.includes(item.value));

            if (selectedGeoRestriction.country_subdivision_iso_codes) {
                const tree = filteredCountries.map((item) => {
                    const lands = item.children.map(i => {
                        return {
                            id: i.id,
                            value: i.value,
                            name: i.text,
                            label: i.text,
                            selected: isCountrySelected(i.value, selectedGeoRestriction.country_subdivision_iso_codes),
                        };
                    });

                    return {value: item.value, name: item.text, label: item.text, children: [...lands]};
                });

                this.setField(sub[selectedGeoRestriction.device_category.name], {
                    hidden: false,
                    options: tree,
                });
            }
        });
    };

    getEntityGeoRestrictions = (entityData) => {
        return _get(entityData, 'eventBooking.event_booking_geo_restrictions', {});
    };

    getDeviceCategoryRestrictions = (restrictions, deviceCategory) => {
        return _findIndex(restrictions, {'device_category': {'id': deviceCategory}});
    };

    handleEntityDataRestrictions = (entityData, continents, countries) => {
        const restrictions = !_isEmpty(entityData) ? this.getEntityGeoRestrictions(entityData) : {},
            desktopRestrictions = this.getDeviceCategoryRestrictions(restrictions, DEVICE_CATEGORY_DESKTOP.toString()),
            mobileRestrictions = this.getDeviceCategoryRestrictions(restrictions, DEVICE_CATEGORY_MOBILE.toString()),
            smartTvRestrictions = this.getDeviceCategoryRestrictions(restrictions, DEVICE_CATEGORY_SMART_TV.toString());

        const devices = [
            {
                deviceCategoryId: DEVICE_CATEGORY_DESKTOP,
                restrictionIndex: desktopRestrictions,
                stateFlagName: 'desktopCountriesGenerated',
            },
            {
                deviceCategoryId: DEVICE_CATEGORY_MOBILE,
                restrictionIndex: mobileRestrictions,
                stateFlagName: 'mobileCountriesGenerated',
            },
            {
                deviceCategoryId: DEVICE_CATEGORY_SMART_TV,
                restrictionIndex: smartTvRestrictions,
                stateFlagName: 'smartTvCountriesGenerated',
            },
        ];

        setCountryRestrictionsForDevices({
            devices: devices,
            restrictions: restrictions,
            continents: continents,
            state: this.state,
            setState: this.setState,
            setField: this.setField,
        });

        const deviceByRestriction = {
            [DEVICE_CATEGORY_DESKTOP]: desktopRestrictions,
            [DEVICE_CATEGORY_MOBILE]: mobileRestrictions,
            [DEVICE_CATEGORY_SMART_TV]: smartTvRestrictions,
        };

        setSubdivisionsRestrictionsForDevices({
            DEVICE_CATEGORIES: this.DEVICE_CATEGORIES,
            deviceByRestriction: deviceByRestriction,
            restrictions: restrictions,
            countries: countries,
            state: this.state,
            setState: this.setState,
            setField: this.setField,
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.props.stepsMethods.setForm('step3', this.props);
        }

        const entityData = _get(this.props, 'GraphQLEntityData', {});
        const {GraphQLOptionsData: {continents, countries}, formValues} = this.props;
        const selectedGeoRestrictionsQueryData = _get(this.state, 'selectedGeoRestrictions'),
            selectedEventEventBookingForGeoRestrictions = _get(selectedGeoRestrictionsQueryData, 'eventEventBooking'),
            selectedGeoRestrictions = _get(selectedEventEventBookingForGeoRestrictions, 'event_booking_geo_restrictions'),
            selectedProduct = _get(this.props.GraphQLEntityData, 'eventEventBooking.product.device_categories', []);

        if (selectedGeoRestrictionsQueryData
            || (this.props.formParams.optionsVariables.client && continents)) {
            if ((this.props?.GraphQLOptionsData?.continents && continents !== prevProps.GraphQLOptionsData.continents)
                || (this.state.selectedGeoRestrictions && this.state.selectedGeoRestrictions !== prevState.selectedGeoRestrictions)
                && continents
            ) {
                this.addSelectedGeoRestrictions(selectedGeoRestrictions);
            }
        }

        if (selectedProduct && this.props.GraphQLOptionsData !== prevProps.GraphQLOptionsData) {
            selectedProduct.map(deviceCategory => deviceCategory.id).forEach((deviceCategoryId) => {
                const deviceName = getDeviceNameById(parseInt(deviceCategoryId));

                this.setField(`${deviceName}_switch`, {
                    hidden: false,
                });
            });
        }

        if (entityData) {
            this.handleEntityDataRestrictions(entityData, continents, countries);
        }

        if (formValues !== prevProps.formValues || countries !== prevProps.GraphQLOptionsData.countries) {
            this.setupDeviceCategoriesCallbacks();
        }
    }

    renderSaveButton = (props) => {
        return super.renderSaveButton({
            ...props,
            content: 'Save',
        });
    };

    deleteButtonClick = (e) => {
        showDefaultDeleteModal(this, e);
    };
}

export default withRouter(EventEventBookingGeoRestrictionsEditForm);
